const infractionTypeInfractionAPI = require('../infraction/infractionType');

const infractionType = {
  refundRequest: 1,
  refundCanceled: 2,
  convertToJDPI(type) {
    switch (type) {
      case infractionTypeInfractionAPI.REFUND_REQUEST:
        return this.refundRequest;
      case infractionTypeInfractionAPI.REFUND_CANCELLED:
        return this.refundCanceled;
      default:
        throw new Error('Invalid infraction type to convert to JDPI');
    }
  },
  convertFromJDPI(type) {
    switch (type) {
      case this.refundRequest:
        return infractionTypeInfractionAPI.REFUND_REQUEST;
      case this.refundCanceled:
        return infractionTypeInfractionAPI.REFUND_CANCELLED;
      default:
        throw new Error('Invalid infraction type to convert from JDPI');
    }
  }
};

module.exports = infractionType;
